import { IComponentOptions } from "angular";
import { GamingContractDetailMachineComponentController } from "./controller";

export const vsComponentName = "gamingContractDetailMachineComponent";

export const gamingContractDetailMachineComponentOptions: IComponentOptions = {
  controller: GamingContractDetailMachineComponentController,
  controllerAs: "gamingContractMachineController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    defaultQuery: "<",
  },
};
